import React from 'react';
import { useSelector } from 'react-redux';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Logs from 'components/Logs';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Feature from 'components/Feature';
import Comments from 'components/Comments';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { legacyGridSafeContainerSx, legacyGridSafeItemSx } from 'theme/legacyGridInterop';
import { Details } from 'components/VehiclesGroups';
import { useParams, useHistory } from 'react-router-dom';
import DocumentsWidget from 'components/Documents/Widget';
import {
  RulesetsWidget,
  VehicleGroupsLabel,
  VehicleGroupImages,
  VehicleGroupLocations,
  VehicleGroupsPricingRules,
  VehicleGroupServicesWidget,
} from 'components/VehiclesGroups';

export const FleetsDetails = () => {
  const history = useHistory();
  const { id } = useParams();
  const { current } = useSelector((state) => state.vehiclesGroups);
  const { core } = useSelector((state) => state.config?.settings || {});
  const hasPricingRulesSetEnabled = core?.pricing?.pricing_rules_set || false;
  const vehicleGroupId = parseInt(id);
  const user = useSelector((state) => state.auth.user || {}) || {};

  if (isNaN(vehicleGroupId)) {
    history.push(buildUrl('/fleets'));
    return <></>;
  }

  return (
    <Layout
      title={i18n.t('vehicle_groups.details', {
        type: VehicleGroupsLabel(),
      })}
    >
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
          <Grid size={12} style={{ marginBottom: 16 }}>
            <Title
              title={`${i18n.t('vehicle_groups.details', {
                type: VehicleGroupsLabel(),
              })}${current?.name ? ' - ' + current.name : ''}`}
            />
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
              <Grid size={{ sm: 12, md: 6, lg: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  <Grid size={12}>
                    <Details id={id} />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <VehicleGroupImages id={vehicleGroupId} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ sm: 12, md: 6, lg: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  <Grid size={12}>
                    <VehicleGroupLocations id={vehicleGroupId} />
                  </Grid>
                  <Grid size={12}>
                    <VehicleGroupServicesWidget id={vehicleGroupId} />
                  </Grid>
                  <Grid size={12}>
                    <DocumentsWidget id={vehicleGroupId} type="vehicle_group" />
                  </Grid>
                  <Grid size={12}>
                    <Comments id={vehicleGroupId} type="vehicle_group" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ sm: 12, md: 6, lg: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  {hasPricingRulesSetEnabled && (
                    <Grid size={12}>
                      <VehicleGroupsPricingRules id={vehicleGroupId} fleet />
                    </Grid>
                  )}
                  {current?.group_type && (
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <Logs
                        title={i18n.t('vehicle_groups.logs', {
                          type: VehicleGroupsLabel(),
                        })}
                        targetType={
                          current?.group_type === 'CUSTOMER'
                            ? 'CustomerVehicleGroup'
                            : 'OwnerVehicleGroup'
                        }
                        targetId={vehicleGroupId}
                        height={400}
                      />
                    </Grid>
                  )}
                  {!core?.subscription?.enabled && user?.role === 'superadmin' && (
                    <Feature name="reservation" is="enabled">
                      <Grid size={12}>
                        <RulesetsWidget id={vehicleGroupId} />
                      </Grid>
                    </Feature>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
